/*
 * @Author: zhujian 
 * @Date: 2019-08-13 11:58:30 
 * @Last Modified by: wufan
 * @Last Modified time: 2019-09-30 16:44:16
 */
declare var SERVER: any
class CONF {
  api = SERVER|| 'https://dev1-heimdall.xiaomai5.com/';
  appId =  'wx3ea60e78ddfa277e'
}


export default new CONF();